import { RootState } from 'editor/src/store/index';

import { isEmbedded } from '../../watchers/useDisplayMode';

import isAddElementsAllowed from './isAddElementsAllowed';

/**
 * GAPI-61895: the Text styles section is opt-in per host (`enableTextStyles`).
 * In the embedded (buyer) editor it additionally follows the template's "Add layers"
 * switch, so a template that keeps its layers fixed does not get a new styling control.
 * Styles already in a design are always applied to their texts; this only gates the control.
 */
const isTextStylesAllowed = (state: RootState) =>
  !!state.hostSettings.enableTextStyles && (!isEmbedded || isAddElementsAllowed(state));

export default isTextStylesAllowed;
